import * as React from 'react';
import { useIsMobileDevice } from '../../hooks';
import { SaveDraftButtonContainer } from '../SaveDraftButton';
import * as styles from './NeedIdentification.css';

export const NeedIdentification = () => {
  const isMobile = useIsMobileDevice();

  return (
    <div className={isMobile ? styles['mobile_wrapper'] : styles['desktop_wrapper']}>
      <SaveDraftButtonContainer />
    </div>
  );
};
